<template>
  <div class="filter-tag-bar-box" v-if="showList">
    <div :class="`show-flex-box-r filter-tag-bar-container-${showType}`">
      <ul class="show-flex-box-r filter-tag-bar-content">
        <li
          :class="{'show-flex-box-r show-flex-center': true, 'is-choosed': choosedType == item.type}"
          v-for="(item, index) in showList"
          :key="index"
          @click="sendClickInfo(item, index)"
        >
          <span>{{ item.title }}</span>
          <strong v-if="item.summary">{{ item.summary }}</strong>
          <em></em>
        </li>
      </ul>
      <div class="white-bar">
        <strong></strong>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import getIndexFunc from '@/tool/getIndexFunc';

export default {
  props: {
    showInfo: [Array],
    showType: [String],
    selectedType: [String],
  },
  data() {
    return {
      showList: null,
      choosedType: '',
    };
  },
  mounted() {
    this.setShowContent();
  },
  watch: {
    showInfo(){
      this.setShowContent();
    },
    selectedType(){
      this.choosedType = this.selectedType;
      this.setScrollBarByIndex();
    },
  },
  methods: {
    setShowContent(){
      if(this.showInfo.length <= 0){
        return ;
      }

      this.showList = this.showInfo;
      this.choosedType = this.selectedType || this.showList[0].type;
      this.setScrollBarByIndex();
    },
    sendClickInfo(item, index){
      if(this.choosedType == item.type){
        return ;
      }

      this.choosedType = item.type;
      
      this.$emit('clickInfo', {
        choosedType: this.choosedType,
        data: item,
        index: index
      });
    },
    setScrollBarByIndex(){
      const liDom = $('.filter-tag-bar-content > li');

      if (liDom.length <= 0) {
        setTimeout(() => {
          this.setScrollBarByIndex();
        }, 100);
        return ;
      }

      let index = getIndexFunc.getIndexById(this.choosedType, this.showList, 'type');

      const offset = liDom.eq(index).find('em').offset();
      const offsetLeft = offset.left;

      let value = `${offsetLeft}px`;
      $('.white-bar > strong').css({'transform': `translateX(${value})`, 'background': '#05BE00'});
    },

  }
};
</script>

<style lang="less" scoped>
.filter-tag-bar-box {
  width: 100%;
  > div{
    // 默认的样式
    position: relative;
    width: 100%;
    height: 0.4rem;
    > ul{
      width: 100%;
      height: 100%;
      > li{
        position: relative;
        width: calc(100% / 3);
        height: 100%;
        flex-shrink: 0;
        > span{
          white-space: nowrap;
          font-size: 0.15rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 0.21rem;
        }
        > strong{
          white-space: nowrap;
          margin-top: 0.02rem;
          margin-left: 0.05rem;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #05BE00;
          line-height: 0.15rem;
        }
        > em{
          position: absolute;
          left: 50%;
          bottom: 0;
          z-index: 9;
          transform: translateX(-50%);
          width: 0.56rem;
          height: 3px;
          background: #05BE00;
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
        }
      }
      > .is-choosed{
        > span{
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        // > em{
        //   opacity: 1;
        // }
      }
    }
    > .white-bar{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 3px;
      z-index: 10;
      > strong{
        transition: all 0.3s;
        display: block;
        width: 0.56rem;
        height: 3px;
      }
    }
  }
  > .filter-tag-bar-container-alignLeft{
    // 另一种样式
    width: 100%;
    box-sizing: border-box;
    padding-left: 0.16rem;
    > ul{
      > li{
        width: 0.6rem;
        margin-right: 0.32rem;
      }
      > li:last-child{
        margin-right: 0;
      }
    }
  }
  > .filter-tag-bar-container-fourTags{
    > ul{
      > li{
        width: calc(100% / 4);
      }
    }
  }
  > .filter-tag-bar-container-twoTags{
    > ul{
      > li{
        width: calc(100% / 2);
        > em{
          width: 0.28rem;
        }
      }
    }
    > .white-bar{
      > strong{
        width: 0.28rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/course/filter_tag_bar_comp.vue